import styled from '@emotion/styled';
import { Theme, StyledProps } from './Tabs.types';
import { space, variant } from 'styled-system';
import css from '@styled-system/css';

const Tab = styled.button<StyledProps, Theme>`
  ${space}

  ${css({
    background: 'none',
    border: 'none',
    outline: 'none',
    position: 'relative',
    fontFamily: 'secondary',

    '&:not(:last-child)': {
      paddingRight: 3,
    },
  })}

  ${variant({
    prop: 'state',
    variants: {
      active: {
        color: 'var(--color-tangerine)',

        '&::after': {
          content: `''`,
          display: 'block',
          margin: '0 auto',
          width: '75%',
          height: '2px',
          top: '100%',
          position: 'absolute',
          bg: 'var(--color-tangerine)',
          borderRadius: 25,
        },
      },

      normal: {
        color: 'var(--color-smoke)',

        '&:hover': {
          background: 'none',
        },

        '&:hover:not(:disabled)': {
          color: 'var(--color-tangerine-70)',
        },

        '&:active': {
          background: 'none',
          color: 'var(--color-smoke)',
        },

        '&:disabled': {
          background: 'none',
          color: 'var(--color-smoke-70)',
        },
      },
    },
  })}
`;

export default Tab;
